import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NotificationsView from '../../classes/notifications';

function NotificationsModal (props) {

  const [SelectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    if (props.NotificationsMsg && props.NotificationsMsg[props.SelectedMsgIndex]) {
      setSelectedMessage(props.NotificationsMsg[props.SelectedMsgIndex]);
    }
    else{
      setSelectedMessage(props.NotificationsMsg)
    }
  }, [props.SelectedMsgIndex, props.NotificationsMsg]);


  useEffect(()=>{

    if(SelectedMessage && !SelectedMessage.bms_leido){
      // console.log(SelectedMessage.bms_leido)
    readNotification(SelectedMessage.bms_id);
    }
  },[SelectedMessage])

  // console.log(SelectedMessage)

  const readNotification = async (id) => {
    let _notifications = new NotificationsView();
    let _res = await _notifications.read1Notification(id);
    if (_res) {
      //   console.log(_res)
      // props.getNotifications();
    }
  };

  const formatMsg = (linea) => {
    const lineaArray = linea.split(/<\/?b>/g);
    return <div className="fs-15 no-margin">{lineaArray.map((word, j) => (
      <React.Fragment key={j}>
        {(j == 1) ? (
          <b>{' ' + word}</b>
        ) : (
          ' ' + word.replace(/<br>/g, "\r\n")
        )}
      </React.Fragment>
    ))}</div>;
  };

  const msgList = () => {
    if (SelectedMessage) {
        return (
          <>
          <tr
            // id={i}
            onClick={(e) => {
              // openModal(e);
              // readNotification(SelectedMessage.bms_id);
            }}
          >
            <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <i className={SelectedMessage.bms_leido ? 'icon-mail' : 'icon-mail blue'} style={{ fontSize: '20px' }}></i>
            </th>
            <th>
              <div className="row">
                <div className="col-sm-6 grey notifications-date">{SelectedMessage.bms_fecha_hora}</div>
                <div className="col-sm-6 grey notifications-email text-right">{SelectedMessage.bms_autor}</div>
              </div>
              <div className="row">
                <div className="col-sm-6 notifications-subject" style={{fontWeight: 'normal'}}>{SelectedMessage.bms_asunto}</div>
              </div>
              {/* <div className='col-sm-12'> */}
                {formatMsg(SelectedMessage.bms_descripcion)}
                {/* </div> */}
              <div className='row'>
              <div className="col-sm-6 notifications-key">{SelectedMessage.bms_clave_seguim}</div>
              <div className='col-sm-6 notifications-key text-right'>{SelectedMessage.bms_sector.charAt(0).toUpperCase() + SelectedMessage.bms_sector.slice(1)}</div>

              </div>
            </th>
          </tr>
          {/* <tr>
            <td>Nº de seguimiento</td>
            <td>{SelectedMessage.bms_clave_seguim}</td>
            <td>Fecha y hora</td>
            <td>{SelectedMessage.bms_fecha_hora}</td>
          </tr>
          <tr>
            <td>Autor</td>
            <td>{SelectedMessage.bms_autor}</td>
            <td>Sector</td>
            <td>{SelectedMessage.bms_sector.charAt(0).toUpperCase() + SelectedMessage.bms_sector.slice(1)}</td>
          </tr>
          <tr>
            <th>Descripción</th>
            <td>{formatMsg(SelectedMessage.bms_descripcion)}</td>
          </tr> */}
          </>
        );
    } else {
      return <h6>No hay mensajes</h6>;
    }
  };


    return (
       <div className="modal-dialog modal-large" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Notificación</h4>
            <button
              className="close"
              onClick={()=>{props.closeModal(); }}
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="table-responsive padding-20">
            <table className="table table-hover mb-0">
              <tbody>{msgList()}</tbody>
            </table>
          </div>
          <div className="modal-footer">
            <Link to='/NotificacionesList'>
            <button
              className="btn btn-primary btn-sm"
              type="button"
              onClick={() => {
                props.closeModal();
              }}
            >
              &nbsp; Ver todos
            </button>
            </Link>
          </div>
        </div>
      </div>
    )
}

export default NotificationsModal;
